import {
  IAlertRepository,
  AlertEntity,
  ResponseValueObject,
} from "@gishub/domain";

export class AlertRepository implements IAlertRepository {
  async getAll(): Promise<ResponseValueObject<AlertEntity[]>> {
    return new ResponseValueObject(true, [
      { id: "precipitacion", name: "Precipitación" },
      { id: "avisos", name: "Avisos" },
    ]);
  }
}
